import * as React from 'react';

type Context = {
  registerInlineEditingField?: (component: React.Component) => void,
  unregisterInlineEditingField?: (component: React.Component) => void
}

const InlineEditingFieldsContext = React.createContext<Context>({});

export default InlineEditingFieldsContext;
